import { Box } from "@mui/material";
import { ReactNode } from "react";

import useSidebarStore from "@/hooks/zustand/ui/useSidebarStore";
import { CONTENT_HEIGHT, PROTRUDING_EDGE_WIDTH, SIDEBAR_TRANSITIONS } from "@/layouts/constants";

interface ContentContainerProps {
  children: ReactNode;
  hideable?: boolean;
  isSidebarVisible?: boolean;
  sidebarWidth: number;
}

export function ContentContainer({
  children,
  hideable = false,
  isSidebarVisible,
  sidebarWidth,
}: ContentContainerProps) {
  const { sidebarOpen } = useSidebarStore();
  const isSidebarOpen = isSidebarVisible && (sidebarOpen || !hideable);

  return (
    <Box
      id="main-section"
      sx={{
        zIndex: 0,
        marginLeft: isSidebarOpen ? `${sidebarWidth}px` : `${PROTRUDING_EDGE_WIDTH}px`,
        width: "100%",
        height: CONTENT_HEIGHT,
        overflowY: "auto",
        transition: SIDEBAR_TRANSITIONS,
      }}
    >
      {children}
    </Box>
  );
}
